module.exports = __webpack_public_path__ + "static/og_image-6b7ac536fae7f8cd6d4bcc4ab47bcf22.png";